var _style, _path, _line, _line2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAngleFavicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 166.22 161.36",
    style: {
      enableBackground: "new 0 0 166.22 161.36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#446688;stroke-width:15;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#DF6347;stroke-width:15;stroke-miterlimit:10;}\n\t.st2{stroke:#FFFFFF;stroke-width:4;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.09,73.94c-8.49,4.77-18.49,7.07-28.92,6.01C73.6,79.18,66.6,76.73,60.52,73"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 159.55,
    y1: 156.25,
    x2: 83.93,
    y2: 8.91
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 6.59,
    y1: 157.78,
    x2: 85.75,
    y2: 12.31
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 85.57,
    cy: 13.65,
    r: 11.65
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleFavicon);
export default __webpack_public_path__ + "static/media/angle_favicon.a0d4d01f28bf08b78d28816fbf17751d.svg";
export { ForwardRef as ReactComponent };